import { render } from "./BirdsEyeDetailView.vue?vue&type=template&id=96e9eb86&scoped=true"
import script from "./BirdsEyeDetailView.vue?vue&type=script&lang=js"
export * from "./BirdsEyeDetailView.vue?vue&type=script&lang=js"

import "./BirdsEyeDetailView.vue?vue&type=style&index=0&id=96e9eb86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e9eb86"]])

export default __exports__